import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { DoremonFile, DoremonService } from '../../services/doremon.service';

@Component({
  selector: 'app-file-upload',
  standalone: false,
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {

  @Input() returnType: 'systemFile' | 'serverFile' | 'viewOnly' = 'serverFile';
  @Input() attachementFile!: DoremonFile;
  @Output() uploadEvent = new EventEmitter<any>;

  constructor(
    private doremonService: DoremonService
  ){}

  onFileChange(event: any) {
    const file = event.target.files?.[0];
    if (file) {
      this.handleFile(file);
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const file = event.dataTransfer?.files?.[0];
    if (file) {
      this.handleFile(file);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    // Optionally handle styling changes
  }

  private async handleFile(file: File) {
    switch(this.returnType){
      case 'serverFile':
        let serverFile:DoremonFile | null = await this.uploadFileToServere(file);
        if(serverFile){
          this.uploadEvent.emit(serverFile);
        }
        break;
      case 'systemFile':
        this.uploadEvent.emit(file);
        break;
    }
  }

  uploadFileToServere(file:any): Promise<DoremonFile | null>{
    return new Promise( resolve => {
      this.doremonService.uploadFile(file).subscribe({
        next: (resp) => {
          resolve(resp);
        },
        error: (error) => {
          resolve(null)
        }
      });
    });
  }

  downloadFile(attachementFile:DoremonFile){
    this.doremonService.downloadDoc(attachementFile.name, attachementFile.id, attachementFile.key, false);
  }

}
